import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { BookingBand } from "@/components/site/BookingBand";
import { Marquee } from "@/components/site/Marquee";
import { SparkleDivider } from "@/components/site/Sparkle";
import { IMG } from "@/data/site";

export default function Testimonials() {
  return (
    <>
      <PageHero
        testId="testimonials-hero"
        eyebrow="Reviews"
        titleLines={["Kind Words,", "Quietly Kept"]}
        quote="What our guests say when the appointment is over."
        image={IMG.spa1}
        imageAlt="A relaxed guest during a spa treatment at S & Z"
      />

      <section data-testid="testimonials-intro" className="bg-ivory pt-24 sm:pt-32 pb-8">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Reveal>
            <SparkleDivider />
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-quote italic font-light text-2xl sm:text-3xl leading-[1.4] text-deep mt-10">
              "We don't chase reviews. We chase results — the words below are
              simply what followed."
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="reviews-widget-section" className="bg-ivory py-16 sm:py-24">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16">
          <Reveal className="text-center mb-12">
            <Eyebrow>
              <span className="mx-auto">Reviews from Google</span>
            </Eyebrow>
            <h2 className="font-display text-3xl sm:text-4xl text-espresso mt-4">
              Kind <span className="italic text-gold">Words</span>
            </h2>
          </Reveal>
          <Reveal>
            {/* Live Elfsight Google Reviews — identical embed to the homepage (app d9dd9941-89e5-4ed1-8b30-9ca126a821ca).
                Reviews update automatically from Google; nothing here is hand-written. platform.js is loaded once in
                index.html, and App.js re-injects it on route change whenever a container has not initialised, so the
                widget renders on direct loads and client-side navigation alike. If it does not render inside the
                preview sandbox, leave this container in place — it will render on the live site.
                Do NOT replace with placeholder reviews. */}
            <div className="elfsight-app-d9dd9941-89e5-4ed1-8b30-9ca126a821ca min-h-[420px]" data-elfsight-app-lazy />
          </Reveal>
        </div>
      </section>

      <Marquee dark />
      <BookingBand />
    </>
  );
}
